var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 14,
    cy: 14,
    r: 14,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1131_2931)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2133 9.79783C15.8846 7.46908 12.1113 7.46533 9.78706 9.78958C7.46131 12.1161 7.46356 15.8878 9.79381 18.2166C12.1226 20.5453 15.8966 20.5483 18.2201 18.2241C20.5451 15.8998 20.5428 12.1266 18.2133 9.79783ZM15.2111 16.5133L13.9451 15.2473L12.6791 16.5133C12.1623 17.0301 11.7738 17.4801 11.1573 16.8643C10.5423 16.2486 10.9901 15.8601 11.5091 15.3426L12.7751 14.0773L11.5091 12.8113C10.9916 12.2946 10.5423 11.9061 11.1573 11.2896C11.7738 10.6746 12.1623 11.1238 12.6791 11.6413L13.9451 12.9058L15.2111 11.6413C15.7286 11.1246 16.1148 10.6738 16.7313 11.2896C17.3478 11.9061 16.8986 12.2946 16.3811 12.8113L15.1151 14.0766L16.3811 15.3418C16.8978 15.8601 17.3478 16.2486 16.7313 16.8643C16.1163 17.4801 15.7286 17.0301 15.2111 16.5133Z",
    fill: "#EC4C47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1131_2931"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFail);
export default __webpack_public_path__ + "static/media/Icon_fail.5a5b5357448039aee745538e539d1051.svg";
export { ForwardRef as ReactComponent };